import { render, staticRenderFns } from "./OrganizationTerms.vue?vue&type=template&id=258e9dd4&scoped=true"
import script from "./OrganizationTerms.vue?vue&type=script&lang=js"
export * from "./OrganizationTerms.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTerms.vue?vue&type=style&index=0&id=258e9dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258e9dd4",
  null
  
)

export default component.exports